/* eslint-disable no-undef */
import EventEmitter from './EventEmitter.js';
import Events from './Events.js';

export default class Sizes {
    constructor() {
        // Setup
        this.menuBarHeight = 50;
        this.width = window.innerWidth;
        this.height = window.innerHeight - this.menuBarHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);

        // Event handling
        this.eventEmitter = new EventEmitter();

        // Resize event
        window.addEventListener('resize', (event) => {
            this.width = window.innerWidth;
            this.height = window.innerHeight - this.menuBarHeight;
            this.pixelRatio = Math.min(window.devicePixelRatio, 2);

            this.eventEmitter.trigger(Events.RESIZE, [event]);
        });
    }
}
